import React from 'react'
import HeaderSection from '../../../../components/common/Header/HeaderSection'
import VoucherAssetsTable from './AssetsTable'
import{Box} from '@chakra-ui/react';
const Assets = () => {
    return (
        <div>
            <HeaderSection
                title="View Assets"
                breadcrumb={["Dashboard", "Voucher", "Assets"]}
            />
            <Box p={6}>
                <VoucherAssetsTable />
            </Box>
        </div>
    )
}

export default Assets